import {isEmpty} from "lodash";
import {createSelector} from "reselect";

const Customers = (state) => state.customers;

export const getCurrentCustomer = createSelector(
  Customers,
  (data) => data.selectedCustomer || {}
);

export const getIsCustomerSelected = createSelector(
  getCurrentCustomer,
  (data) => !isEmpty(data)
);

export const getCustomers = createSelector(
  Customers,
  (customer) => customer.customersList || {}
);

export const getCustomersList = createSelector(
  getCustomers,
  getCurrentCustomer,
  (customers, currentCustomer) =>
    customers?.results?.map((customer) => ({
      ...customer,
      select: customer.id === currentCustomer.id,
    }))
);

export const getCustomerTotalCount = createSelector(
  getCustomers,
  (Customers) => Customers?.total_count
);

export const getCustomerPaginationUrls = createSelector(getCustomers, (Customers) => ({
  prevUrl: Customers?.previous,
  nextUrl: Customers?.next,
}));

export const getCustomersLabelValueList = createSelector(
  Customers,
  (data) => data.customersListLabelValue || []
);
